import React from 'react';
import clsx from 'clsx';
import styles from './AccordionDetails.module.scss';
import '@rmwc/list/styles';

export const AccordionDetails = ({
  className,
  ...props
}: React.ComponentPropsWithRef<'div'>): React.JSX.Element => (
  <div
    className={clsx(className, styles.details)}
    {...props}
  />
);
